// import React, { useState } from "react";
// import styles from "../../assets/scss/Billing/AddBilling.module.scss";

// const TransportHandlersForm = ({ onClose, onAdd }) => {
//   const [paymentType, setPaymentType] = useState("");
//   const [amount, setAmount] = useState("");

//   const [errors, setErrors] = useState({});

//   const validate = () => {
//     let newErrors = {};

//     if (!paymentType) {
//       newErrors.paymentType = "Payment Type is required";
//     }

//     if (!amount) {
//       newErrors.amount = "Amount is required";
//     } else if (Number(amount) <= 0) {
//       newErrors.amount = "Amount must be greater than 0";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = () => {
//     if (!validate()) return;

//     const newEntry = {
//       _id: Date.now().toString(),
//       journalId: `JNL-${Math.floor(Math.random() * 1000)}`,
//       receiptNo: "Manual Entry",
//       createdAt: new Date(),
//       paymentStatus: "Paid",
//       paymentMethod: paymentType,
//       handleBy: { firstName: "Admin", lastName: "" },
//       credit: Number(amount),
//       debit: 0,
//     };

//     onAdd(newEntry);
//     onClose();
//   };

//   return (
//     <div>
//       {/* HEADER */}
//       <div className={styles.header}>
//         <h2 className={styles.tittle}>Add Transport Amount</h2>
//         <span className={styles.closeIcon} onClick={onClose}>
//           ✕
//         </span>
//       </div>

//       {/* FORM */}
//       <div className={styles.AddLedgerEntryformSection}>
//         {/* Payment Type */}
//         <div className={styles.ownerinput}>
//           <label className={styles.inputLabelssss}>
//             Payment Type <span style={{ color: "red" }}>*</span>
//           </label>

//           <select
//             className={`${styles.inputsheader} ${
//               errors.paymentType ? styles.inputError : ""
//             }`}
//             value={paymentType}
//             onChange={(e) => {
//               setPaymentType(e.target.value);
//               setErrors({ ...errors, paymentType: "" });
//             }}
//           >
//             <option value="">Select</option>
//             <option value="Cash">Cash</option>
//             <option value="UPI">UPI</option>
//             <option value="Bank">Bank</option>
//           </select>

//           {errors.paymentType && (
//             <p className={styles.errorText}>{errors.paymentType}</p>
//           )}
//         </div>

//         {/* Amount */}
//         <div className={styles.ownerinput}>
//           <label className={styles.inputLabelssss}>
//             Amount <span style={{ color: "red" }}>*</span>
//           </label>

//           <input
//             className={`${styles.inputlastone} ${
//               errors.amount ? styles.inputError : ""
//             }`}
//             type="number"
//             value={amount}
//             onChange={(e) => {
//               setAmount(e.target.value);
//               setErrors({ ...errors, amount: "" });
//             }}
//             placeholder="Enter Amount"
//           />

//           {errors.amount && (
//             <p className={styles.errorText}>{errors.amount}</p>
//           )}
//         </div>
//       </div>

//       {/* BUTTONS */}
//       <div className={styles.ownerinputs}>
//         <button className={styles.cancelBtnlast} onClick={onClose}>
//           Cancel
//         </button>
//         <button className={styles.saveBtnlast} onClick={handleSubmit}>
//           Add
//         </button>
//       </div>
//     </div>
//   );
// };

// export default TransportHandlersForm;

import React, { useState } from "react";
import styles from "../../assets/scss/Billing/AddBilling.module.scss";
import { useSettleTempEmployeeAmountMutation } from "../../slices/admin/admin";
import { toast } from "react-toastify";

const TransportHandlersForm = ({ onClose, empId }) => {
  const [paymentType, setPaymentType] = useState("");
  const [amount, setAmount] = useState("");
  const [errors, setErrors] = useState({});

  const [settleAmount, { isLoading }] =
    useSettleTempEmployeeAmountMutation();

  const validate = () => {
    let newErrors = {};

    if (!paymentType) {
      newErrors.paymentType = "Payment Type is required";
    }

    if (!amount) {
      newErrors.amount = "Amount is required";
    } else if (Number(amount) <= 0) {
      newErrors.amount = "Amount must be greater than 0";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      const response = await settleAmount({
        empId,
        body: {
          amount: Number(amount),
          paymentMethod: paymentType.toLowerCase(),
        },
      }).unwrap();

      toast.success(response?.message || "Settlement Successful");

      toast.info(
        `Paid: ₹${response?.paidAmount} | Wallet: ₹${response?.walletCreditedAmount}`
      );

      onClose();

    } catch (error) {
      toast.error(
        error?.data?.message || "Something went wrong"
      );
    }
  };

  return (
    <div>
      <div className={styles.header}>
        <h2 className={styles.tittle}>Pay Transport Amount</h2>
        <span className={styles.closeIcon} onClick={onClose}>
          ✕
        </span>
      </div>

      <div className={styles.AddLedgerEntryformSection}>
        {/* Payment Type */}
        <div className={styles.ownerinput}>
          <label className={styles.inputLabelssss}>
            Payment Type <span style={{ color: "red" }}>*</span>
          </label>

          <select
            className={`${styles.inputsheader} ${
              errors.paymentType ? styles.inputError : ""
            }`}
            value={paymentType}
            onChange={(e) => {
              setPaymentType(e.target.value);
              setErrors({ ...errors, paymentType: "" });
            }}
          >
            <option value="">Select</option>
            <option value="cash">Cash</option>
            <option value="upi">UPI</option>
            <option value="bank">Bank</option>
          </select>

          {errors.paymentType && (
            <p className={styles.errorText}>{errors.paymentType}</p>
          )}
        </div>

        {/* Amount */}
        <div className={styles.ownerinput}>
          <label className={styles.inputLabelssss}>
            Amount <span style={{ color: "red" }}>*</span>
          </label>

          <input
            className={`${styles.inputlastone} ${
              errors.amount ? styles.inputError : ""
            }`}
            type="number"
            value={amount}
            onChange={(e) => {
              setAmount(e.target.value);
              setErrors({ ...errors, amount: "" });
            }}
            placeholder="Enter Amount"
          />

          {errors.amount && (
            <p className={styles.errorText}>{errors.amount}</p>
          )}
        </div>
      </div>

      <div className={styles.ownerinputs}>
        <button className={styles.cancelBtnlast} onClick={onClose}>
          Cancel
        </button>
        <button
          className={styles.saveBtnlast}
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? "Processing..." : "Pay"}
        </button>
      </div>
    </div>
  );
};

export default TransportHandlersForm;